(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-videos"] && !Shopify.designMode) return;
  try {
    
  const updateReelArrows = (root) => {
    if (!root) return;
    const track = root.querySelector('.reel-videos__track');
    const prev = root.querySelector('.reel-videos__arrow[data-direction="prev"]');
    const next = root.querySelector('.reel-videos__arrow[data-direction="next"]');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    if (prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 4);
    if (next) next.classList.toggle('is-hidden', track.scrollLeft >= max - 4);
  };

  const initReelArrows = () => {
    document.querySelectorAll('.reel-videos').forEach(updateReelArrows);
  };

  document.addEventListener('click', (event) => {
    const play = event.target.closest('.reel-videos__play');
    if (play) {
      const video = play.closest('.reel-videos__media')?.querySelector('video');
      if (video) {
        video.muted = false;
        video.controls = true;
        video.play();
        play.remove();
      }
      return;
    }
    const button = event.target.closest('.reel-videos__arrow');
    if (!button) return;
    const root = button.closest('.reel-videos');
    const track = root?.querySelector('.reel-videos__track');
    const item = track?.querySelector('.reel-videos__item');
    if (!track || !item) return;
    const gap = parseFloat(getComputedStyle(track).gap) || 12;
    const delta = item.getBoundingClientRect().width + gap;
    track.scrollBy({
      left: button.dataset.direction === 'prev' ? -delta : delta,
      behavior: 'smooth',
    });
  });

  // Scroll events don't bubble, so listen in the capture phase.
  document.addEventListener(
    'scroll',
    (event) => {
      if (event.target instanceof Element && event.target.classList.contains('reel-videos__track')) {
        updateReelArrows(event.target.closest('.reel-videos'));
      }
    },
    true
  );

  window.addEventListener('resize', initReelArrows);
  document.addEventListener('shopify:section:load', initReelArrows);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReelArrows);
  } else {
    initReelArrows();
  }

  } catch(e) { console.error(e); }
})();
})();
